import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { DepositoAssignResponse } from "./assign-deposito";

export async function getDepositoActual(token: string): Promise<DepositoAssignResponse> {
    await sleep(1000);
    const response = await api.get("deposito_actual", {
        headers: { "X-Deposito-Token": token }
    });

    return { ...response.data, token };
}
